module.exports = __webpack_public_path__ + "img/sms.bb3168de.svg";